/**
 * Grabs the data we dump from the server into the DOM and exports them as a singleton.
 * This allows us to conveniently dump server data into the dom and use this to load
 * that data into our app.
 */
import { WorldReady } from '@paypalcorp/worldready';
import { ServerData } from '../typings/Common';
import { logErrorClient } from './beaverLogger';

const serverData = {} as ServerData;

export interface Data extends ServerData {
  serializedServerData?: string;
  serializedFptiConfigs?: string;
}

function init(data: Data) {
  if (!data) {
    return;
  }

  try {
    const serverDataDetails = JSON.parse(data.serializedServerData || '{}');
    const serverFPTIConfig = JSON.parse(data.serializedFptiConfigs || '{}');
    Object.assign(serverData, { ...data, ...serverDataDetails, ...serverFPTIConfig });

    if (process.env.NODE_ENV !== 'test' && serverData?.worldReady) {
      WorldReady.load(serverData.worldReady);
    }
  } catch (err) {
    logErrorClient('server-data: ', err.toString());
  }
}

const supportedCurrencies = () => {
  return serverData.accountCurrencies || [];
};

export default serverData;
export { init, supportedCurrencies };
